export default __webpack_public_path__ + "static/media/sombra8.edc27bee.png";